import { graphql } from "react-relay";

export const eventSummaryAutopilotFlexFragments = {
  event: graphql`
    fragment EventSummaryAutopilotFlex_event on Event {
      annotatedEvent {
        orgTags {
          tag
          state {
            active
            value
            subjectType
          }
        }
      }
      annotatedRecurringEvent {
        orgTags {
          tag
          state {
            active
            value
            subjectType
          }
        }
      }
    }
  `,
};
